const findFirstDefinedScopeIndex = (item) => {
    if (!item || !Array.isArray(item.scopes)) {
        return -1;
    }

    return item.scopes.findIndex((scope) => scope && scope.scope_from_verse != undefined);
};

export const createContentComparator = (verseKeys = []) => (a, b) => {
    const aFirstIndex = findFirstDefinedScopeIndex(a);
    const bFirstIndex = findFirstDefinedScopeIndex(b);

    if (aFirstIndex !== bFirstIndex) {
        return aFirstIndex - bFirstIndex;
    }

    if (aFirstIndex < 0) {
        return 0;
    }

    const aVerses = verseKeys[aFirstIndex];
    const bVerses = verseKeys[bFirstIndex];

    if (!Array.isArray(aVerses) || !Array.isArray(bVerses)) {
        return 0;
    }

    const aPosition = aVerses.indexOf(a.scopes[aFirstIndex].scope_from_verse);
    const bPosition = bVerses.indexOf(b.scopes[bFirstIndex].scope_from_verse);

    if (aPosition < 0 || bPosition < 0) {
        return 0;
    }

    return aPosition - bPosition;
};
